import { render, staticRenderFns } from "./ShipInfoReview.vue?vue&type=template&id=7e08a504"
import script from "./ShipInfoReview.vue?vue&type=script&lang=js"
export * from "./ShipInfoReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports